import React, { FC, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { IDepoimentosContext } from "../../../../Context/Depoimentos/Interfaces/IDepoimentosContext";
import styles from "./Depoimentos.module.scss";

interface IDepoimentos {
  depoimentosContext: IDepoimentosContext;
}

export const Depoimentos: FC<IDepoimentos> = ({ depoimentosContext }) => {
  useEffect(() => {
    depoimentosContext.effects && depoimentosContext.effects.getDepoimentos();
  }, []);

  return (
    <div
      className={`${styles["Depoimentos"]}  ${
        isMobile ? styles["mobile"] : ""
      }`}
    >
      <div className={styles["Container"]}>
        <span className={styles["Title"]}>Depoimentos</span>
        {depoimentosContext.result.data.map((item, idx) => {
          return (
            <div key={`depoimento-${item.nome}`} className={styles["Group"]}>
              <div className={styles["Content"]}>
                <span className={styles["Text"]}>
                  <span>“</span>
                  {item.descricao}
                  <span className={styles["second"]}>“</span>
                </span>
                <span className={styles["ClientName"]}>{item.nome}</span>
              </div>
              <div className={styles["Foto"]} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
